import { createRoot } from 'react-dom/client';
import '../app/globals.css';
import RealMathUniverse from '../components/RealMathUniverse';

const rootElement = document.getElementById('rmu-container');

if (!rootElement) {
  throw new Error("Missing #rmu-container element");
}

createRoot(rootElement).render(<RealMathUniverse />);
